import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CouponIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CouponIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M18.488 19.0752H5.51193C4.34103 19.0752 3.23019 18.5098 2.53976 17.5625C1.84982 16.6157 1.82247 15.2788 2.47189 14.2363L3.86447 12L2.47189 9.76367C1.82248 8.72119 1.84982 7.38428 2.53976 6.4375C3.2297 5.49023 4.34103 4.9248 5.51193 4.9248H18.488C19.6584 4.9248 20.7697 5.49023 21.4602 6.4375C22.1501 7.38428 22.1775 8.72119 21.528 9.76367L20.1355 12L21.528 14.2363C22.1774 15.2788 22.1501 16.6157 21.4602 17.5625C20.7692 18.5098 19.6579 19.0752 18.488 19.0752ZM5.51193 5.92481C4.65939 5.92481 3.85031 6.33643 3.34836 7.02637C2.89572 7.64698 2.88449 8.53467 3.32053 9.23535L4.87766 11.7358C4.97873 11.8975 4.97873 12.1025 4.87766 12.2642L3.32053 14.7647C2.88449 15.4653 2.89573 16.353 3.34836 16.9736C3.8508 17.6636 4.65988 18.0752 5.51193 18.0752H18.488C19.3396 18.0752 20.1486 17.6631 20.6521 16.9736C21.1042 16.353 21.1154 15.4653 20.6794 14.7647L19.1223 12.2642C19.0212 12.1025 19.0212 11.8975 19.1223 11.7358L20.6794 9.23535C21.1154 8.53467 21.1042 7.64697 20.6516 7.02637C20.1491 6.33643 19.34 5.92481 18.488 5.92481H5.51193Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.79074 15.6382C7.51437 15.6382 7.29074 15.4146 7.29074 15.1382V8.86182C7.29074 8.58545 7.51437 8.36182 7.79074 8.36182C8.06711 8.36182 8.29074 8.58545 8.29074 8.86182V15.1382C8.29074 15.4146 8.06711 15.6382 7.79074 15.6382Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2092 15.6382C15.9328 15.6382 15.7092 15.4146 15.7092 15.1382V8.86182C15.7092 8.58545 15.9328 8.36182 16.2092 8.36182C16.4856 8.36182 16.7092 8.58545 16.7092 8.86182V15.1382C16.7092 15.4146 16.4856 15.6382 16.2092 15.6382Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CouponIcon;
